import { useEffect, useState } from "react"
import { useFormContext, FormProvider } from "react-hook-form"
import { setTokenSourceMapRange } from "typescript"

export default function Question(question: any) {
    const form = useFormContext()
    const { register, watch, setValue, formState: { errors, isSubmitting } } = form
    const { setStep } = question
    const field = watch(`${question.ID}`)
    const [disabled, setDisabled] = useState<boolean>(false)
    const [exit, setExit] = useState<string>(``)

    const questionType = () => {
        if (question.meta.type === 'intro') return
        const _register = register(`${question.ID}`)

        switch (question.meta.type) {
            case 'text':
            case 'email':
                return <input className="form-control" placeholder={question.meta.placeholder} type={question.meta.type} {..._register} />
            case 'textarea':
                return <textarea className="form-control" placeholder={question.meta.placeholder} {..._register}></textarea>
            case 'radio':
            case 'checkbox':
                return (
                    question.meta.options.map((option: any, key: number) => {
                        return (
                            <label key={key}><input disabled={((disabled && !option.explicite) || (field && question.meta.max_answers && question.meta.max_answers <= Object.values(field).length && !field.includes(option.choice))) ? true : false} type={question.meta.type} {..._register} value={option.choice} /> {option.choice}</label>
                        )
                    })
                )

            default:
                break
        }
    }
    const prevQuestion = () => {
        setStep(watch('step') - 1)
    }

    useEffect(() => {
        if (!question) return
        var hasExit = false
        question?.meta?.options?.map((option: any, key: number) => {
            if (field && field.includes(option.choice)) {
                if (option.weight && option.weight.length) {
                    option.weight.map((_option: any) => {
                        if (_option.exit) {
                            setExit(_option.url)
                            hasExit = true
                        }
                    })
                }
            } else if (!hasExit) {
                setExit(``)
            }

            if (option.explicite) {
                if (field && field.includes(option.choice) && !disabled) {
                    setDisabled(true)
                    setValue(`${question.ID}`, [option.choice])

                } else if (field && !field.includes(option.choice)) {
                    setDisabled(false)
                }
            }
        })
    }, [field])

    return (
        <FormProvider {...form}>
            <div className={'question h-100'} style={question.meta.background ? { backgroundImage: `url("${question.meta.background}")` } : {}}>
                <div className={'col-lg-6 col-12 text-center'}>
                    <h3>{question.post_title}</h3>

                    {question.post_content && <div dangerouslySetInnerHTML={{ __html: question.post_content }}></div>}

                    <p className={`margin-center ${errors[question.ID] ? 'is-invalid mb-0' : ''}`}>
                        {questionType()}
                    </p>
                    <div className="invalid-feedback mb-2">{question.meta.error ? question.meta.error : errors[question.id]?.message}</div>

                    <p>
                        {watch('step') > 1 && <button className={'previous-button'} type={'button'} onClick={() => prevQuestion()}>Back</button>}

                        {exit !== `` ?
                            (<a href={exit} className={'btn btn-primary btn-lg'}>{question.meta.button}</a>)
                            :
                            (<button className={'btn btn-primary btn-lg'} disabled={isSubmitting} type={'submit'}>{question.meta.button}</button>)}
                    </p>

                    {errors.general && (<div className="alert alert-danger">{errors.general.message}</div>)}
                </div>
            </div>
        </FormProvider >
    )
}